module.exports = __webpack_public_path__ + "static/media/12-7.830a6fdc.mp3";